import { type FAQSection } from "../types/faq";

export const motiveFaqs: FAQSection[] = [
  {
    title: "General Questions",
    value: "general-questions",
    items: [
      {
        title: "What is the Motive Investor Portal?",
        body: "The Motive Investor Portal is a secure, centralized platform designed for Motive's investors to access available funds for them to invest in on the portal. Future expansions of the portal will also allow the user to review their investments' reporting data, manage their account information and access portfolio analytics functionalities.",
      },
      {
        title: "Why did we launch this new portal?",
        body: "As part of Motive's continued commitment to transparency, innovation, and operational excellence, we launched a new Investor Portal that delivers enhanced functionality, modern design, and improved performance. The new platform provides a more intuitive user experience and streamlined processes to onboard to our funds.",
      },
      {
        title: "Who is the portal designed for?",
        body: "The Motive Investor Portal is available to institutional investors, financial advisors, and individual investors (including identified proxies) who hold investments across Motive-managed funds or vehicles. You can self-service invite team members via the settings pages of the portal to help with your subscription.",
      },
    ],
  },
  {
    title: "Access and Security",
    value: "access-and-security",
    items: [
      {
        title: "How do I gain access to the Motive Investor Portal?",
        body: "The Investor Portal will be accessible through any web browser via desktop or mobile device. After being invited by the Motive team or one of your team members, you will receive an invitation email containing a secure link to register or log in to the portal. If you or a colleague did not receive an invitation, please reach out to subscriptions@motivepartners.com.",
      },
      {
        title: "What credentials do I use to log in?",
        body: 'During your first login after receiving the platform\'s welcome email, you will be asked to set up your account credentials. If you have forgotten your password, click "Forgot Password" on the sign-in page to reset your credentials. Should you have any issues logging in, please reach out to subscriptions@motivepartners.com.',
      },
      {
        title: "Is my data secure?",
        body: "Yes. The portal leverages industry-standard encryption and advanced monitoring to protect investor information. Motive adheres to strict cybersecurity and data privacy protocols across all systems, e.g. demonstrated by the platform's SOC 2 Type 2 certification.",
      },
      {
        title: "Can multiple users from my organization have access?",
        body: "Yes. As many authorized users as you wish can be provisioned under a single investor organization. User roles and permissions can be customized to allow multiple levels of access. You will be able to add contacts to your account directly in the portal or ask our support staff to do so on your behalf.",
      },
    ],
  },
  {
    title: "Support and Feedback",
    value: "support-and-feedback",
    items: [
      {
        title: "How do I raise questions during the subscription process?",
        body: 'Use the "Help with this question" button in the upper right corner of the subscription questionnaire to leave any questions to the Motive team.',
      },
      {
        title:
          "Who can I contact for support or to provide feedback on the portal?",
        body: "For support and feedback on the portal, please email product@vega.investments or use the feedback form in the settings → support page.",
      },
    ],
  },
];
